<template>
    <div class="brand-list">
        <div class="right_top clearfix">
            <Row>
                <Col span="20">
                    <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
                        <FormItem>
                            <Select v-model="formItem.type" clearable placeholder="请选择App类型">
                                <Option v-for="type in typeList" :key="type.id" :value="type.id">{{type.name}}</Option>
                            </Select>
                        </FormItem>
                        <FormItem>
                            <Button type="primary" @click="renderTable(1)">查找</Button>
                        </FormItem>
                    </Form>
                </Col>
                <Col span="4">
                    <div class="f-r">
                        <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
                            <FormItem>
                                <Button type="primary" @click="addVersion">添加版本</Button>
                            </FormItem>
                        </Form>
                    </div>
                </Col>
            </Row>
        </div>
        <Table border :columns="columns" ref="tableList" :data="tablelist" :loading="dataloading" class="mt10" />
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;">
                <Page ref="listPage" :total="pages.total" :current="pages.page" :page-size="pages.size" show-elevator show-total @on-change="changePage()"></Page>
            </div>
        </div>
        <Modal v-model="showEditInfoStatus" title="修改品牌" @on-ok="updateVersion('versionValidate')" :loading="loading">
            <Form :model="version" ref="versionValidate" :rules="versionValidate" action="javascript:void(0)">
                <FormItem label="App名称" prop="name">
                    <Select v-model="version.type" clearable placeholder="请选择App类型">
                        <Option v-for="type in typeList" :key="type.id" :value="type.id">{{type.name}}</Option>
                    </Select>
                </FormItem>
                <FormItem label="版本号" prop="version">
                    <Input v-model="version.version" placeholder="输入版本号..."></Input>
                </FormItem>
                <FormItem label="是否强制升级" label-position="top">
                    <RadioGroup v-model="version.status">
                        <Radio :label="0">否</Radio>
                        <Radio :label="1">是</Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem label="下载地址" prop="address">
                    <Input v-model="version.address" placeholder="请输入下载地址..." ></Input>
                </FormItem>
                <FormItem label="升级提示文案" prop="upgrade_info">
                    <Input v-model="version.upgrade_info" placeholder="请输入升级提示文案..." type="textarea"></Input>
                </FormItem>
            </Form>
        </Modal>
    </div>
</template>

<script>

    export default {
        name: 'VersionList',
        data() {
            const validateSelectVersion = (rule, value, callback) => {
                if (this.version.type === "") {
                    callback(new Error("请选择App"));
                } else {
                    callback();
                }
            };
            return {
                dataloading: true,
                columns: [
                    {
                        title: 'Id',
                        key: 'id',
                        width: 80,
                        // fixed: 'left'
                    },
                    {
                        title: 'App名称',
                        width: 150,
                        key: 'type',
                        render: (h, params) => {
                            return h('span', {
                                style: {
                                    marginLeft: params.row.left + 'px'
                                }
                            }, this.getAppName(params.row.type))
                        }
                    },
                    {
                        title: '版本号',
                        width: 150,
                        key: 'version',
                        render: (h, params) => {
                            return h('span', {
                                style: {
                                    marginLeft: params.row.left + 'px'
                                }
                            }, params.row.version)
                        }
                    },
                    {
                        title: '强制升级',
                        key: 'status',
                        width: 150,
                        render: (h, params) => {
                            return h(
                                "tag",
                                {
                                    props: {
                                        color:
                                            params.row.status == 1 ? "green" : "orange"
                                    }
                                },
                                params.row.status == 1 ? "是" : "否"
                            );
                        }
                    },
                    {
                        title: '下载地址',
                        minWidth: 150,
                        key: 'address',
                    },
                    {
                        title: '提示文案',
                        minWidth: 150,
                        key: 'upgrade_info',
                        render: (h, params) => {
                            return h('span', {
                                style: {
                                    marginLeft: params.row.left + 'px'
                                }
                            }, params.row.upgrade_info)
                        }
                    },
                    {
                        title: '操作',
                        key: 'action',
                        width: 130,
                        align: 'left',
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'info',
                                        size: 'small'
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.edit(params.row.id)
                                        }
                                    }
                                }, '修改'),
                                h('Button', {
                                    props: {
                                        type: 'error',
                                        size: 'small'
                                    },
                                    on: {
                                        click: () => {
                                            this.remove(params.row.id)
                                        }
                                    }
                                }, '删除')
                            ]);
                        }
                    }
                ],
                tablelist: [],
                version: {
                    id: '',
                    type: '',
                    version: '',
                    status: 0,
                    upgrade_info:'',
                    address:''
                },
                typeList: [],
                showEditInfoStatus: false,
                loading: false,
                showModalStatus: false,
                versionValidate: {
                    name: [
                        { required: true, validator: validateSelectVersion, trigger: "change" }
                    ],
                    version: [
                        { required: true, message: '版本号必须填写', trigger: 'blur' }
                    ],
                    upgrade_info: [
                        { required: true, message: '升级提示文案必须填写', trigger: 'blur' }
                    ],
                    address: [
                        { required: true, message: '下载地址必须填写', trigger: 'blur' }
                    ],
                },
                formItem: {
                    type: '',
                },
                pages: {
                    page: 1,
                    size: 10,
                    total: 0
                }
            }
        },
        // 计算
        computed: {
        },
        // 监听
        watch: {
        },
        created: function() {
            // 取数据
            this.getTableList();
        },
        components: {
        },
        methods: {
            getAppName(typeId) {
                for (let i = 0; i < this.typeList.length; i++) {
                    const type = this.typeList[i];
                    if (type.id == typeId) {
                        return type.name
                    }
                }
                return ''
            },
            renderTable() {
                this.pages.page = 1
                this.getTableList()
            },
            changePage() {
                this.pages.page = this.$refs['listPage'].currentPage;
                this.getTableList();
            },
            getTableList: function() {
                var params = {
                    type: this.formItem.type,
                    page: this.pages.page,
                    size: this.pages.size
                }
                this.$api.appVersion.list(params).then(res => {
                    // console.log(res)
                    this.dataloading = false;
                    if (res.code == 200) {
                        this.tablelist = res.result.list;
                        this.pages.total = res.result.total;
                        this.typeList = res.result.typeList
                        this.$Message.success(res.msg);
                    }
                });
                this.dataloading = false;
            },
            edit: function(index) {
                this.$refs['versionValidate'].resetFields();

                // 取信息
                this.$api.appVersion.detail({id:index}).then(res=>{
                    if(res.code == 200) {
                        this.version = res.result;
                        this.showEditInfoStatus = true;
                        this.$Message.success(res.msg);
                    }
                    this.loading = false;
                    this.$nextTick(() => {this.loading = true;});
                });

            },
            addVersion() {
                this.$refs['versionValidate'].resetFields();
                this.version = {
                    id: '',
                    type: '',
                    version: '',
                    status: 0,
                    upgrade_info:'',
                    address:''
                }
                this.showEditInfoStatus = true;
            },
            updateVersion(name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        if (this.version.id != null && this.version.id != undefined && this.version.id != '') {
                            this.$api.appVersion.edit(this.version).then(res=>{
                                if(res.code == 200) {
                                    this.$Message.success(res.msg);
                                    this.showEditInfoStatus = false;
                                    this.getTableList();
                                } else {
                                    this.showEditInfoStatus = true;
                                }
                                this.loading = false;
                                this.$nextTick(() => {this.loading = true;});
                                // this.showCreateStatus = !this.showCreateStatus;
                            });
                        } else {
                            this.$api.appVersion.create(this.version).then(res=>{
                                if(res.code == 200) {
                                    this.$Message.success(res.msg);
                                    this.showEditInfoStatus = false;
                                    this.getTableList();
                                } else {
                                    this.showEditInfoStatus = true;
                                }
                                this.loading = false;
                                this.$nextTick(() => {this.loading = true;});
                                this.showCreateStatus = !this.showCreateStatus;
                            });
                        }

                    } else {
                        this.$Message.error('请检查输入的信息是否正确！');
                        this.loading = false
                        this.$nextTick(() => {this.loading = true;});
                        this.showEditInfoStatus = true;
                    }
                })
            },
            // 删除
            remove: function(id) {
                // 弹出确认框
                var that = this
                this.$Modal.confirm({
                    title: '警告',
                    content: '<p>此操作不可恢复，三思而后行...</p>',
                    onOk: () => {
                        that.$api.appVersion.remove({ id: id }).then(res => {
                            if (res.code == 200) {
                                that.$Message.success(res.msg);
                                that.getTableList();
                            }
                        });
                    }
                });
            },
        }
    }
</script>
